module.exports = __webpack_public_path__ + "pic_bizny_web_04-375@2x.png?1f739081d4e3c9d886b9188fa2d5207f";